<template>
  <material-card>
    <v-layout slot="header" px-3>
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Świadczone usługi</div>

        <p>Lista usług udostępnianych przez Partnera</p>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs6 class="mt-3">
        <ul style="list-style: none;">
          <li>Aktywne usługi - oznaczone kolorem zielonym</li>

          <li>Ukryte usługi - oznaczone kolorem szarym</li>
        </ul>
      </v-flex>

      <v-flex text-xs-right>
        <check-permission permissions="BENEFIT.ADD" entity-type="partner" :entity-id="partnerId">
          <v-btn large color="error" @click="showAddModal">DODAJ USŁUGĘ</v-btn>
        </check-permission>

        <check-permission permissions="SHARED_BENEFIT.ASSIGN">
          <v-btn large color="blue darken-2" dark @click="assigmentModal = true">EDYTUJ PRZYPISANE USŁUGI</v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <v-layout v-for="item in list" :key="item.id" row>
      <v-flex xs2>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on">
              <v-avatar :class="State[item.state] === State.ACTIVE ? 'secondary' : 'tertiary'">
                <v-icon color="white">{{ item.displayType }}</v-icon>
              </v-avatar>
              {{ item.displayValue }}
            </v-chip>
          </template>

          <span>{{ benefitType(item.type) }}</span>
        </v-tooltip>
      </v-flex>

      <v-flex xs7>
        <h3>
          {{ item.name }}

          <v-tooltip v-if="item.shared" top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-share-variant</v-icon>
            </template>

            <span>Usługa współdzielona</span>
          </v-tooltip>
        </h3>

        <p>
          <span v-if="State[item.state] === State.HIDDEN">Ukryta </span>

          <span v-else-if="State[item.state] !== State.ACTIVE">Oczekuje na akceptację </span>

          <span
            v-if="
              item.state === 'ACTIVE' &&
                item.newer &&
                item.newer.some(item => State[item.state] === State.NOT_CONFIRMED)
            "
          >
            Nowsza wersja oczekuje akceptacji
          </span>

          <span v-if="item.place" class="mr-2">
            <v-icon small class="mr-1">mdi-bank</v-icon>

            <span>{{ item.place.name }} </span>
          </span>

          <span v-if="item.displayGroups" class="mr-2">
            <v-icon small class="mr-1">mdi-account-group</v-icon>

            <span>{{ item.displayGroups }}</span>
          </span>

          <span v-if="item.displayCategories" class="mr-2">
            <v-icon small class="mr-1">mdi-pound</v-icon>

            <span v-html="item.displayCategories" />
          </span>

          <span v-if="item.start || item.end">
            <v-icon small class="mr-1">mdi-calendar</v-icon>

            <span v-if="item.start && item.end">Ważna od {{ item.start }} do {{ item.end }}</span>

            <span v-else-if="item.start">Ważna od {{ item.start }}</span>

            <span v-else-if="item.end">Ważna do {{ item.end }}</span>
          </span>
        </p>
      </v-flex>

      <v-flex v-if="!item.shared" xs3 class="text-xs-right">
        <check-permission
          v-if="!item.newer || item.newer.every(item => State[item.state] !== State.NOT_CONFIRMED)"
          permissions="BENEFIT.UPDATE"
          entity-type="benefit"
          :entity-id="item.id"
        >
          <v-btn icon flat color="primary" @click="showEditModal(item.id)">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </check-permission>

        <check-permission permissions="BENEFIT.DELETE" entity-type="benefit" :entity-id="item.id">
          <v-btn icon flat color="error" @click="showDeleteDialog(item.id)">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <add :id="idToEdit" :show="showModal" @close="hideModal" @update="update" @save="add" />

    <material-dialog
      :id="idToDelete"
      title="Potwierdź usunięcie"
      text="Usunięcie usługi spowoduje wysłanie wiadomości do Administratora Usteckiej Karty Mieszkańca. Czy na pewno chcesz usunąć usługę?"
      :show="!!idToDelete"
      @close="hideDeleteDialog"
      @confirm="remove"
    />
    <check-permission permissions="SHARED_BENEFIT.ASSIGN">
      <assigment-modal
        v-if="sharedBenefits"
        :id="partnerId"
        type="benefit"
        :current="sharedBenefits"
        :show="assigmentModal"
        @close="assigmentModal = false"
      />
    </check-permission>
  </material-card>
</template>

<script>
import {
  BenefitIconTypeTranslation,
  BenefitType,
  benefitType,
  DisplayBenefitType,
  PublicSettings,
  State
} from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import AssigmentModal from '@/components/modals/Assigment.modal';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import Add from './modals/AddBenefit.modal';

// @vuese
// Wyświetlanie usług Partnera
// @group Partners
export default {
  components: {
    MaterialCard,
    MaterialDialog,
    Add,
    AssigmentModal
  },
  mixins: [
    modalMixin('partners/benefits', {
      getError: 'Wystąpił błąd podczas pobierania danych usługi.',
      added: 'Dodano usługę.',
      addError: 'Nie udało się dodać usługi.',
      updated: 'Zaktualizowano usługę.',
      updateError: 'Nie udało się zaktualizować usługi.'
    }),
    notificationsMixin
  ],
  data() {
    return {
      idToDelete: undefined,
      State,
      assigmentModal: false
    };
  },
  computed: {
    ...mapState({
      list: state => state.partners.benefits.list,
      sharedBenefits: state =>
        state.partners.benefits.list
          .filter(benefit => benefit.shared)
          .map(benefit => ({ name: benefit.name, id: benefit.id })),
      partnerId: state => state.partners.id,
      noGroupSetting: state => state.settings.settings[PublicSettings.NO_GROUP_SELECTED_NAME].value
    })
  },
  watch: {
    list(array) {
      this.setDisplayData(array);
    }
  },
  beforeMount() {
    this.setDisplayData(this.list);
  },
  methods: {
    // @vuese
    // Metoda dostosowuje usługę do prawidłowego wyświetlenia informacji
    // @arg `list` - tablica usług
    setDisplayData(list) {
      list.forEach(benefit => {
        benefit.displayType = BenefitIconTypeTranslation[BenefitType[benefit.type]];

        if (benefit.type === DisplayBenefitType.PERCENT_DISCOUNT) {
          benefit.displayValue = benefit.value + ' %';
        } else {
          benefit.displayValue = benefit.value;
        }

        if (benefit.groups && benefit.groups.length) {
          benefit.displayGroups = benefit.groups.map(group => group.name).join(', ');
        } else {
          benefit.displayGroups = this.noGroupSetting;
        }

        if (benefit.categories) {
          benefit.displayCategories = benefit.categories
            .map(category => {
              if (category.state !== State[State.ACTIVE]) {
                return `<span style="color: red">${category.name}</span>`;
              }
              return category.name;
            })
            .join(', ');
        }
      });
    },
    // @vuese
    // Otwiera okienko z potwierdzeniem usunięcia
    // @arg `id` - identyfikator usługi
    showDeleteDialog(id) {
      this.idToDelete = id;
    },
    // @vuese
    // Ukrywa okienko z potwierdzeniem usunięcia
    hideDeleteDialog() {
      this.idToDelete = undefined;
    },
    // @vuese
    // Usuwa usługę
    // @arg `id` - identyfikator usługi
    remove(id) {
      this.$store
        .dispatch('partners/benefits/remove', id)
        .then(() => this.notifySuccess('Usunięto usługę.'))
        .catch(err => this.notifyError('Nie udało się usunąć usługi.'));
    },
    benefitType
  }
};
</script>

<style>
table {
  width: 100%;
}
td {
  white-space: nowrap;
}
.mainText {
  width: 100%;
  padding-left: 0.5em;
}
</style>
